// extracted by mini-css-extract-plugin
export default {"tab":"security_tab__zbDV3","row":"security_row__b5II+"};